const { VUE_APP_TYPE } = process.env
import { App_User } from '@/data/user_info'
export default {
    install (_Vue) {
        _Vue.mixin({
            data () {
                return {
                    app_type: VUE_APP_TYPE
                }
            },
            methods: {
                $checkPostAuth () {
                    if (this.app_type === 'tft') {
                        document.getElementById('mini_qr_dlg').style.display = 'block'
                        return false
                    }
                    return true
                },
                async $checkUserLogging() {
                    const data = await App_User.get()
                    if (data.tag_list && data.tag_list[0] == "天府通游客") {
                        wx.navigateTo({
                            url: '/logging_in'
                        })
                        return false
                    }
                    return true
                }
            }
        })
    }
}
